export enum localStorageEnum {
    USER = "user",
    ACCOUNT_GOVBR = "account",
    REDIRECT_URL = "redirect-url"
}